
import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(6, 182, 212, 0.3), rgba(59, 130, 246, 0.3)), url('https://public.readdy.ai/ai/img_res/1349ca0a57e9954c03c2384778d5bfc7.jpg')`
        }}
      >
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              El Futuro de la 
              <span className="bg-gradient-to-r from-cyan-300 to-yellow-400 bg-clip-text text-transparent"> Educación</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed">
              Prepara a tus estudiantes para el mundo digital con nuestro curso completo de 
              <strong className="text-white"> Inteligencia Artificial</strong> diseñado especialmente para instituciones educativas
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Link 
                to="/curso"
                className="bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-cyan-500 hover:to-blue-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>
                Ver Presentación
              </Link>
              <Link 
                to="/precios"
                className="bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all shadow-lg hover:shadow-xl whitespace-nowrap border border-white/30"
              >
                <i className="ri-price-tag-3-line mr-2"></i>
                Ver Precios
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div className="bg-gradient-to-br from-green-400/20 to-cyan-500/20 backdrop-blur-sm rounded-2xl p-6 border border-green-300/30">
                <div className="w-16 h-16 bg-gradient-to-r from-green-400 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-graduation-cap-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">24 Módulos</h3>
                <p className="text-blue-100">Programa completo estructurado en 5 niveles progresivos</p>
              </div>
              
              <div className="bg-gradient-to-br from-red-400/20 to-pink-500/20 backdrop-blur-sm rounded-2xl p-6 border border-red-300/30">
                <div className="w-16 h-16 bg-gradient-to-r from-red-400 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-group-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Todos los Niveles</h3>
                <p className="text-blue-100">Desde preescolar hasta secundaria, adaptado a cada edad</p>
              </div>
              
              <div className="bg-gradient-to-br from-blue-400/20 to-purple-500/20 backdrop-blur-sm rounded-2xl p-6 border border-blue-300/30">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-settings-3-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">100% Personalizable</h3>
                <p className="text-blue-100">Interfaz editable para adaptar el contenido a tus necesidades</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              ¿Por qué es Crucial la <span className="text-cyan-300">IA en la Educación</span>?
            </h2>
            <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed">
              La Inteligencia Artificial no es solo el futuro, es el presente. Los estudiantes que dominen estas tecnologías 
              tendrán ventajas significativas en su desarrollo académico y profesional.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-cyan-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-brain-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Desarrollo del Pensamiento Crítico</h3>
                  <p className="text-blue-100">La IA fomenta el razonamiento lógico, resolución de problemas complejos y toma de decisiones informadas.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-purple-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-rocket-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Preparación para el Futuro</h3>
                  <p className="text-blue-100">85% de los trabajos del 2030 aún no existen. La IA será fundamental en la mayoría de las profesiones.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-400 to-pink-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Estimula la Creatividad</h3>
                  <p className="text-blue-100">Los estudiantes aprenden a usar la IA como herramienta creativa para proyectos innovadores.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-red-400 to-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Ventaja Competitiva</h3>
                  <p className="text-blue-100">Los estudiantes que comprenden IA tienen mejores oportunidades académicas y laborales.</p>
                </div>
              </div>
            </div>

            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Split%20comparison%20image%20showing%20students%20with%20AI%20technology%20on%20left%20side%20looking%20confident%20and%20successful%20versus%20traditional%20students%20on%20right%20side%2C%20educational%20technology%20comparison%2C%20bright%20modern%20classroom%20environment%2C%20diverse%20children%2C%20professional%20educational%20photography&width=600&height=400&seq=comparison-main&orientation=landscape"
                alt="Comparación estudiantes con IA vs sin IA"
                className="rounded-2xl shadow-2xl w-full"
              />
              <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-4 shadow-lg border border-white/20">
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-400">92%</div>
                  <div className="text-sm text-blue-200">Mejor rendimiento</div>
                </div>
              </div>
            </div>
          </div>

          {/* Statistics */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
              <div className="text-3xl font-bold text-cyan-400 mb-2">78%</div>
              <div className="text-blue-100">Mejora en resolución de problemas</div>
            </div>
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
              <div className="text-3xl font-bold text-green-400 mb-2">65%</div>
              <div className="text-blue-100">Mayor creatividad e innovación</div>
            </div>
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
              <div className="text-3xl font-bold text-purple-400 mb-2">89%</div>
              <div className="text-blue-100">Mejor preparación digital</div>
            </div>
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
              <div className="text-3xl font-bold text-yellow-400 mb-2">94%</div>
              <div className="text-blue-100">Mayor motivación académica</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 via-blue-700 to-cyan-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ¿Listo para Transformar la Educación?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Únete a las instituciones líderes que ya están preparando a sus estudiantes para el futuro
          </p>
          <Link 
            to="/curso"
            className="bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center border border-white/30"
          >
            <i className="ri-play-circle-line mr-2"></i>
            Descubre Nuestro Curso
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
